import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'

import { Player } from '@ppwr/poker'

import { useActualHeight } from '../../../hooks/use-actual-height'
import { useStore } from '../../../models'
import { PlayerCell, PlayerCellProps } from '../PlayerCell'

export interface PlayerColumnProps extends Omit<PlayerCellProps, 'player'> {
  players: Player[]
  right?: boolean
  isTeacher?: boolean
}

export const PlayerColumn = observer(({ players, onPlayerCellPress, right, isTeacher }: PlayerColumnProps) => {
  const {
    game: { isRaiseOrFold, isTableTour }
  } = useStore()
  const HEIGHT = useActualHeight()
  const isSmallerDevice = HEIGHT < 670
  return (
    <View
      style={[
        {
          gap: players.length === 4 ? undefined : !isSmallerDevice || isRaiseOrFold ? 40 : 20,
          justifyContent: players.length < 4 ? 'center' : 'space-evenly'
        },
        { flex: 1 }
      ]}
    >
      {players.map((player) => (
        <View key={`player-cell-view-${player.id}`} style={[styles.playerContainer, isTableTour ? { flex: 1 } : {}]}>
          <PlayerCell
            key={`player-cell-${player.id}`}
            right={right}
            player={player}
            onPlayerCellPress={isTeacher ? onPlayerCellPress : undefined}
            numberOfPlayers={players.length}
          />
        </View>
      ))}
    </View>
  )
})

const styles = StyleSheet.create({
  playerContainer: {
    justifyContent: 'center'
  }
})
